window.Lend = {}